import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { AccountDashboardBanner as AccountDashboardBannerBase } from "./AccountDashboardBanner";

export type * from "./AccountDashboardBanner";

export const AccountDashboardBanner = withLoyaltyStore(AccountDashboardBannerBase, "AccountDashboardBanner");
